import { SVGProps } from 'react';

const DoubleArrowLeft = ({
  width = '8',
  height = '11',
  className = '',
  color = 'var(--brand-bg-primary)',
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8 11"
    width={width}
    height={height}
    className={className}
    color={color}
    data-palette="DoubleArrowLeft">
    <g fill="currentColor">
      <path d="M1.454 5.333L4 8.445 3.273 9.333 0 5.333 3.273 1.333 4 2.222zM5.454 5.333L8 8.445 7.273 9.333 4 5.333 7.273 1.333 8 2.222z" />
    </g>
  </svg>
);

export default DoubleArrowLeft;
